import PageSEO from '@/components/feature/PageSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategoriesSection from './components/CategoriesSection';
import ActivitiesSection from './components/ActivitiesSection';
import ArticlesSection from './components/ArticlesSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '17c一起',
  url: 'https://17cyiqi.com',
  description: '17c一起是汇聚志同道合伙伴的互动平台，随时随地与朋友、同好一起行动、一起分享、一起成长。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://17cyiqi.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '17c一起',
  url: 'https://17cyiqi.com',
  description: '17c一起 - 相聚共享，连接你我他。汇聚志同道合伙伴的互动社交平台。',
  sameAs: ['https://weibo.com/17cyiqi', 'https://weixin.qq.com/17cyiqi'],
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="相聚共享，连接你我他"
        description="17c一起是汇聚志同道合伙伴的互动平台，随时随地与朋友、同好一起行动、一起分享、一起成长。发现更多共同兴趣，开启全新社交体验。"
        keywords="17c一起, 17c一起活动, 17c一起社交, 17c一起平台, 一起相聚, 共享互动社区, 志同道合交友"
        canonicalUrl="https://17cyiqi.com/"
      />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />

      <Navbar />
      <main>
        <Hero />
        <CategoriesSection />
        <ActivitiesSection />
        <StatsSection />
        <ArticlesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}